export default {"src":"/_next/static/media/pilot_guide.525148c9.svg","height":50,"width":51,"blurWidth":0,"blurHeight":0};